import React from 'react';
import '../styles/Loader.css'; // You can add your custom styling here

const SyncLoader = ({message}) => {
  return (
    <div className="sync-loader">
  <div className="loader-content">
    <div className="spinner"></div>
    {message && <div className="loader-message">{message}</div>}
  </div>
</div>
  );
};

export default SyncLoader;
